document.querySelectorAll('.icon-text-carousel__container').forEach((container) => {
    const root = container.closest('.icon-text-carousel');
    const track = container.querySelector('.icon-text-carousel__track');
    const viewport = container.querySelector('.icon-text-carousel__viewport');
    const prevBtn = container.querySelector('.icon-text-carousel__nav--prev');
    const nextBtn = container.querySelector('.icon-text-carousel__nav--next');

    if (!root || !track || !viewport) {
        return;
    }

    let isAnimating = false;

    function getMinSlideWidth() {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        const mobileRaw = root.dataset.slideMinWidthMobile;
        if (isMobile && mobileRaw && String(mobileRaw).trim() !== '') {
            const m = parseInt(mobileRaw, 10);
            if (Number.isFinite(m) && m > 0) {
                return m;
            }
        }
        const raw = root.dataset.slideMinWidth || '220';
        const n = parseInt(raw, 10);
        return Number.isFinite(n) && n > 0 ? n : 220;
    }

    function getMaxVisible() {
        const raw = root.dataset.slideMaxVisible || '4';
        const n = parseInt(raw, 10);
        if (!Number.isFinite(n) || n < 1) {
            return 4;
        }
        return Math.min(n, 8);
    }

    function getVisibleCount() {
        const vw = viewport.offsetWidth;
        const minW = getMinSlideWidth();
        const maxVis = getMaxVisible();
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        let count = Math.floor(vw / minW);
        count = Math.max(1, Math.min(count, maxVis));
        // Desktop: prefer 4 columns when there is enough horizontal room (matches CHECK24 LP)
        if (!isMobile && maxVis >= 4 && track.children.length >= 4) {
            const widthIfFour = Math.floor(vw / 4);
            if (count < 4 && widthIfFour >= minW - 32) {
                count = 4;
            }
        }
        return count;
    }

    function layoutItems() {
        const count = getVisibleCount();
        const itemWidth = viewport.offsetWidth / count;
        Array.from(track.children).forEach((item) => {
            item.style.width = `${itemWidth}px`;
            item.style.minWidth = `${itemWidth}px`;
        });
    }

    function goNext() {
        if (isAnimating) return;
        isAnimating = true;

        const count = getVisibleCount();
        const itemWidth = viewport.offsetWidth / count;

        track.style.transition = 'transform 0.3s ease';
        track.style.transform = `translateX(-${itemWidth}px)`;

        track.addEventListener('transitionend', function handler() {
            track.removeEventListener('transitionend', handler);
            track.style.transition = 'none';
            track.appendChild(track.firstElementChild);
            track.style.transform = 'translateX(0)';
            isAnimating = false;
        }, { once: true });
    }

    function goPrev() {
        if (isAnimating) return;
        isAnimating = true;

        const count = getVisibleCount();
        const itemWidth = viewport.offsetWidth / count;

        track.style.transition = 'none';
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        track.style.transform = `translateX(-${itemWidth}px)`;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                track.style.transition = 'transform 0.3s ease';
                track.style.transform = 'translateX(0)';

                track.addEventListener('transitionend', function handler() {
                    track.removeEventListener('transitionend', handler);
                    isAnimating = false;
                }, { once: true });
            });
        });
    }

    if (!prevBtn || !nextBtn) {
        return;
    }

    prevBtn.addEventListener('click', goPrev);
    nextBtn.addEventListener('click', goNext);

    layoutItems();
    window.addEventListener('resize', layoutItems);
});
